import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from "./_virtual/_rollupPluginBabelHelpers.js";
var Cache = /* @__PURE__ */ function() {
  function Cache2() {
    _classCallCheck(this, Cache2);
    _defineProperty(this, "_data", /* @__PURE__ */ Object.create(null));
  }
  _createClass(Cache2, [{
    key: "set",
    value: function set(id, data) {
      this._data[id] = data;
    }
  }, {
    key: "get",
    value: function get(id) {
      return this._data[id];
    }
  }, {
    key: "clear",
    value: function clear() {
      this._data = /* @__PURE__ */ Object.create(null);
    }
  }]);
  return Cache2;
}();
export { Cache };
